import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const CR = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;
const AR = { "1:1": "1 / 1", "4:5": "4 / 5", "9:16": "9 / 16" };

export const CreativePicker = ({ onClose, onPick }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { axios.get(CR).then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  const ok = (it) => !(it.kind === "image" && it.aspect_ratio === "9:16");

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="creative-picker-dialog" className="max-h-[88vh] max-w-3xl overflow-y-auto">
        <DialogHeader><DialogTitle>Alege un creativ din galerie</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500">Imaginile 9:16 nu se pot posta în feed-ul Instagram. Video-urile se publică ca video pe Facebook și Reel pe Instagram.</p>
        {items === null ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : (
          <div className="grid grid-cols-3 items-start gap-3 md:grid-cols-4">
            {items.map((it) => (
              <button key={it.id} data-testid={`creative-pick-${it.id}`} disabled={!ok(it)} onClick={() => onPick(it.id)} className="overflow-hidden rounded-lg border border-zinc-200 text-left transition-transform hover:scale-[1.02] hover:border-amber-500 disabled:cursor-not-allowed disabled:opacity-30">
                {it.kind === "video"
                  ? <video src={it.url} muted loop playsInline onMouseEnter={(e) => e.target.play().catch(() => {})} onMouseLeave={(e) => e.target.pause()} style={{ aspectRatio: AR[it.aspect_ratio] || "1 / 1" }} className="w-full bg-black object-cover" />
                  : <img src={`${it.url}?w=360`} alt="" loading="lazy" style={{ aspectRatio: AR[it.aspect_ratio] || "1 / 1" }} className="w-full object-cover" />}
                <p className="truncate px-1.5 py-1 text-[10px] text-zinc-500">{it.sku || ""} · {it.aspect_ratio || "1:1"} · {it.kind === "video" ? "video" : it.upscaled ? "4K" : "imagine"}</p>
              </button>
            ))}
            {items.length === 0 && <p className="col-span-full text-sm text-zinc-500">Galeria e goală — generează întâi în Creative Ads.</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
